module.exports = __webpack_public_path__ + "img/featuredartist (8).58c94bbe.jpg";